import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { IntroComponent } from './intro/intro.component';
import { MenuComponent } from './menu/menu.component';
import { LayoutComponent } from './layout/layout.component';
import { HeaderComponent } from './header/header.component';
import { PanadolComponent } from './panadol/panadol.component';
import { PanadolExtraComponent } from './panadol-extra/panadol-extra.component';
import { PanadolKidsComponent } from './panadol-kids/panadol-kids.component';
import { GuidelinesComponent } from './guidelines/guidelines.component';
import { SuitabilityComponent } from './suitability/suitability.component';
import { ReferenceComponent } from './reference/reference.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    IntroComponent,
    MenuComponent,
    LayoutComponent,
    HeaderComponent,
    PanadolComponent,
    PanadolExtraComponent,
    PanadolKidsComponent,
    GuidelinesComponent,
    SuitabilityComponent,
    ReferenceComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
